import { render, staticRenderFns } from "./UpdateProjectDialog.vue?vue&type=template&id=29ce35fc&scoped=true&"
import script from "./UpdateProjectDialog.vue?vue&type=script&lang=ts&"
export * from "./UpdateProjectDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ce35fc",
  null
  
)

export default component.exports